var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 48.8762C12.5 44.5168 14.6778 40.7213 17.7694 39.6954L25.0854 37.2729L28.7767 43.2873C29.422 44.8196 31.0325 44.8196 31.6779 43.2873L35.2987 37.44L42.6166 39.7528C45.7405 40.7422 47.9545 44.5586 47.9545 48.9571L47.728 51.3561C47.728 53.3687 46.5401 55.0002 45.0723 55.0002H15.3327C13.865 55.0002 12.6751 53.3687 12.6751 51.3561L12.5 48.8762Z",
    stroke: "#001823",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3341 33.9489C24.6036 33.9489 19.1477 27.7464 19.1477 20.0994C19.1477 12.4503 24.6036 6.25 31.3341 6.25C38.0668 6.25 43.5227 12.4503 43.5227 20.0994",
    stroke: "#DB3725",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.091 20.0993C39.091 25.3014 35.6176 29.5169 31.3353 29.5169C27.0529 29.5169 23.5796 25.3014 23.5796 20.0993C23.5796 14.8997 27.0529 10.6816 31.3353 10.6816C35.6176 10.6816 39.091 14.8997 39.091 20.0993Z",
    stroke: "#001823"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5512 33.9488C33.5512 35.1734 32.5585 36.1647 31.3362 36.1647C30.1121 36.1647 29.1194 35.1734 29.1194 33.9488C29.1194 32.7242 30.1121 31.7329 31.3362 31.7329C32.5585 31.7329 33.5512 32.7242 33.5512 33.9488Z",
    fill: "#DB3725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7018 16.2217C19.6693 16.2217 18.9943 16.2217 18.9618 16.2217C16.9177 16.2282 15.266 18.2164 15.27 20.6648C15.2754 23.1116 16.9353 25.0917 18.9794 25.0852C19.0051 25.0852 19.3244 25.0852 19.3514 25.0852L19.7018 16.2217Z",
    fill: "#DB3725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.8b677bb563ae26556b2d505515dcea97.svg";
export { ForwardRef as ReactComponent };